import React, { useEffect,useState } from 'react'
import { Link } from 'react-router-dom'
import { all_routes } from '../../../router/all_routes'
import { DatePicker } from 'antd';
import CommonSelect from '../../../../core/common/commonSelect';
import { Student } from '../../../../types/dataModel';
import {API} from '../../../../common/Constants'
import useFetch from '../../../../hooks/useFetch';
import PreLoader from '../../../../core/common/preLoader';
import { getAPIHeaders, isValidPhoneNumber, isValidEmail } from '../../../../common/Utils';
import {toCamelCase} from '../../../../common/Utils'

type PasswordField = "password" | "confirmPassword";

interface Props {
  onSuccess: ()=> void
  classOpts: any[]
}

const OnboardStudent = ({onSuccess, classOpts}:Props) => {
    const [student, setStudent] = useState<Student>()
    const [errorMessage, setErrorMessage] = useState<string | undefined>("");
    const {isLoading, error, data, status, callFetch } = useFetch();
    const [showMsgBox, setShowMsgBox] = useState<boolean|null>(false)

    useEffect(()=>{
      setShowMsgBox(false)
    },[])

    useEffect(() => {
          if(data && status && status < 299){
              reset();
              setShowMsgBox(true)
              onSuccess()
          }
     }, [status]);

    useEffect(() => {
        if(error){
          if(error.response?.data){
            setErrorMessage(error.response?.data)
          } else{
            setErrorMessage('Something went wrong please try again later.')
          }
        }
    }, [error]);

  const handleSubmit = (event:any) => {
      event.preventDefault()
      if(!student?.batchId){
        setErrorMessage("Please select a batch")
      } else if(!student?.firstName){
        setErrorMessage("Please provide a first name")
      } else if(!student?.lastName){
        setErrorMessage("Please provide last name")
      } else if(!student?.dob){
        setErrorMessage("Please select date of birth")
      } else if(!isValidEmail(student?.email)){
        setErrorMessage("Please provide a valid email address")
      } else if(!isValidPhoneNumber(student?.phoneNumber)){
        setErrorMessage("Please provide a valid phone number")
      }  else if(!student?.username){
        setErrorMessage("Please provide a username")
      } else if(student?.confirmPassword !== student?.password){
        setErrorMessage("Password and Confirm Password Mismatch")
      } else {
        setErrorMessage("")
        callFetch(API.STUDENT,
            'POST',
            getAPIHeaders(),
            null,
            {
                ...student
            }
        ).catch((error) => {});
      }
    }

    const reset = () => {
      setStudent(undefined)
    }

    const getModalContainer = () => {
        const modalElement = document.getElementById('modal-datepicker');
        return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
    };
    const [passwordVisibility, setPasswordVisibility] = useState({
        password: false,
        confirmPassword: false,
    });

    const togglePasswordVisibility = (field: PasswordField) => {
        setPasswordVisibility((prevState) => ({
        ...prevState,
        [field]: !prevState[field],
        }));
    };

    const renderMsgBox = () => {
      return (          
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body text-center">
              <span className="avatar avatar-xl bg-transparent-success text-success mb-3">
                  <i className="ti ti-thumb-up fs-36" />
              </span>
              <h4 className="mb-1">Student Onboarding Successfull</h4>
              <p className="mb-3">
                  Student is onboarded successfully.
              </p>
              <div className="d-flex justify-content-center">
                  <Link to="#" 
                      data-bs-dismiss="modal" 
                      className="btn btn-success"
                      onClick={()=>{
                        setTimeout(() => {
                          setShowMsgBox(false);
                        }, 1000);
                        }}>
                      Close
                  </Link>
              </div>
          </div>
      </div>
    </div>)
    }

    const renderForm = () => {
      return (     
        <div className="modal-dialog modal-dialog-centered modal-lg" >
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Add New Student</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form action={all_routes.students}>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Onboarding Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="info-tab"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Class <span className="text-danger"> *</span></label>
                          <CommonSelect
                            options={classOpts}
                            onChange={(value: any) => {
                              setStudent({
                                ...student,
                                batchId: parseInt(value)
                              });
                            }}    
                            formatOptionLabel={(item)=>{
                              return (
                                <span className='d-flex align-content-center gap-2'>
                                {item.data.batchName}-{item.data.batchSection}{"  "}
                                <span
                                  className={`badge badge-xs rounded-pill bg-${item.data.curriculumStatus === "ACTIVE"
                                    ? 'success' : item.data.curriculumStatus === "UPCOMING" ? 'info' : 'primary'}`}
                                >
                                  {toCamelCase(item?.data.curriculumStatus)}
                                </span>
                              </span>
                              )
                            }}              
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Roll Number</label>
                          <input type="text" className="form-control" 
                          value={student?.rollNumber}
                          onChange={(e)=>{setStudent({
                            ...student,
                            rollNumber: e.target.value
                          })}}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            First Name <span className="text-danger"> *</span>
                          </label>
                          <input type="text" className="form-control" 
                          value={student?.firstName}
                          onChange={(e)=>{setStudent({
                            ...student,
                            firstName: e.target.value
                          })}}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Last Name <span className="text-danger"> *</span></label>
                          <input type="email" className="form-control" 
                            value={student?.lastName}
                            onChange={(e)=>{setStudent({
                              ...student,
                              lastName: e.target.value
                            })}}/>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Gender <span className="text-danger"> *</span></label>
                            <CommonSelect
                              options={[
                                  {
                                  label: "Male",
                                  value: "M"
                                },{
                                  label: "Female",
                                  value: "F"
                                },{
                                  label: "Others",
                                  value: "O"
                                }
                              ]
                              }
                              onChange={(value)=>{setStudent({
                                ...student,
                                gender: value
                              })}}
                            />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Date Of Birth <span className="text-danger"> *</span>
                          </label>
                          <div className="input-icon-end position-relative">
                            <DatePicker
                              className="form-control datetimepicker"
                              format={{
                                format: "DD-MM-YYYY",
                                type: "mask",
                              }}
                              getPopupContainer={getModalContainer}
                              placeholder="DD-MM-YYYY"
                              onChange={(value:any)=>{
                                setStudent({
                                  ...student,
                                  dob: value?.toDate()?.getTime()/1000
                                })
                              }}
                            />
                            <span className="input-icon-addon">
                              <i className="ti ti-calendar text-gray-7" />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Email <span className="text-danger"> *</span>
                          </label>
                          <input type="email" className="form-control"
                              value={student?.email}
                              onChange={(e)=>{
                                setStudent({
                                ...student,
                                email: e.target.value
                                })}} />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label">
                              Phone Number <span className="text-danger"> *</span>
                            </label>
                            <input type="text" className="form-control" 
                                value={student?.phoneNumber}
                                onChange={(e)=>{
                                  setStudent({
                                  ...student,
                                  phoneNumber: e.target.value? parseInt(e.target.value) : undefined
                                })}}
                                onKeyPress={(e) => {
                                  if (!/[0-9]/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                            />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Username <span className="text-danger"> *</span>
                          </label>
                          <input type="text" className="form-control" 
                              value={student?.username}
                              onChange={(e)=>{
                                setStudent({
                                ...student,
                                username: e.target.value
                                })}}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3 ">
                          <label className="form-label">
                            Password <span className="text-danger"> *</span>
                          </label>
                          <div className="pass-group">
                            <input
                              type={
                                passwordVisibility.password
                                  ? "text"
                                  : "password"
                              }
                              className="pass-input form-control"
                              value={student?.password}
                              onChange={(e)=>{
                                setStudent({
                                ...student,
                                password: e.target.value
                                })}}
                            />
                            <span
                              className={`ti toggle-passwords ${passwordVisibility.password
                                ? "ti-eye"
                                : "ti-eye-off"
                                }`}
                              onClick={() =>
                                togglePasswordVisibility("password")
                              }
                            ></span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3 ">
                          <label className="form-label">
                            Confirm Password <span className="text-danger"> *</span>
                          </label>
                          <div className="pass-group">
                            <input
                              type={
                                passwordVisibility.confirmPassword
                                  ? "text"
                                  : "password"
                              }
                              className="pass-input form-control"
                              value={student?.confirmPassword}
                              onChange={(e)=>{
                                setStudent({
                                ...student,
                                confirmPassword: e.target.value
                                })}}
                            />
                            <span
                              className={`ti toggle-passwords ${passwordVisibility.confirmPassword
                                ? "ti-eye"
                                : "ti-eye-off"
                                }`}
                              onClick={() =>
                                togglePasswordVisibility("confirmPassword")
                              }
                            ></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer" style={{ justifyContent: "space-between"}}>
                    <div>
                      { errorMessage  ?
                        <>
                          <i className="ti ti-alert-triangle text-danger" />  
                          <span className='text-danger'> {errorMessage} </span> 
                        </> 
                        : <></>
                      }
                    </div>
                    <div>
                      <button
                        type="button"
                        className="btn btn-outline-light border me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button type="button" 
                        className="btn btn-primary" 
                        onClick={handleSubmit}>
                        Save{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      )
    }

    return (
      <div className="modal fade" id="add_student"                
      data-bs-backdrop="static"
      data-bs-keyboard="false">
        <PreLoader showLoader={isLoading} />
        {showMsgBox ? renderMsgBox() : renderForm()}
      </div>
    )
}

export default OnboardStudent